import { render } from "./NewBusinessRuleActionSendDashboard.vue?vue&type=template&id=769f6304"
import script from "./NewBusinessRuleActionSendDashboard.vue?vue&type=script&lang=js"
export * from "./NewBusinessRuleActionSendDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__